<template>
  <div :data-detail-image-src="props.src">
    <img
      v-if="isDevMode && !failedLoad"
      class="w-full"
      :src="resolvedSrc"
      @error="handleImgError"
    />
    <TwicImg
      v-else-if="!failedLoad"
      ratio="594/425"
      class="w-full"
      :src="resolvedSrc"
      auto="format,compress"
      eager="true"
      sizes="(min-width: 1000px) 50vw, 96vw"
      placeholder="none"
      @stateChange="handleStateChange"
    />
    
    <!--img
      v-else     
      :src="'/images/missing.jpg'"     
    /-->
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { useRuntimeConfig } from '#app'

const emit = defineEmits(['error'])

const pendingLoad = ref(true)
const failedLoad = ref(false)

function handleStateChange({ state }) {
  switch (state) {
    case 'done':
      pendingLoad.value = false
      break
    case 'error':
      failedLoad.value = true
      emit('error', props.src)
      break
    case 'loading':
      // Optionally set pendingLoad true here
      break
    default:
      // Do nothing
  }
}

function handleImgError() {
  failedLoad.value = true
  emit('error', props.src)
}

const props = defineProps({
  src: { type: String, required: true }
})
const config = useRuntimeConfig()
const isDevMode = import.meta.dev
const resolvedSrc = computed(() =>
  props.src + '?deployment=' + config.public.appVersion
)

watch(
  () => props.src,
  () => {
    // Reset error status when src changes
    failedLoad.value = false
    pendingLoad.value = true
  }
)
</script>
